webpackJsonp([4869420489019],{

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ritual_duvel_glass.0857ae94.jpg";

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  opacity: ', ';\n  margin-top: ', ';\n  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;'], ['\n  opacity: ', ';\n  margin-top: ', ';\n  transition: opacity ease-out 0.5s, margin-top cubic-bezier(0, 0, 0.58, 1) 1s;']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  opacity: ', ';\n  transform: ', ';\n  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;'], ['\n  opacity: ', ';\n  transform: ', ';\n  transition: opacity ease-out 0.5s, transform cubic-bezier(0, 0, 0.58, 1) 1s;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactPlayer = __webpack_require__(105);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _reactWaypoint = __webpack_require__(55);
	
	var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);
	
	var _reactEmotion = __webpack_require__(54);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Revealable = (0, _reactEmotion2.default)("div")(_templateObject, function (_ref) {
	  var show = _ref.show;
	  return show ? "100" : "0";
	}, function (_ref2) {
	  var show = _ref2.show;
	  return show ? "0" : "100px";
	});
	
	var Reveal = function (_Component) {
	  _inherits(Reveal, _Component);
	
	  function Reveal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Reveal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      revealed: false
	    }, _this.reveal = function () {
	      _this.setState({ revealed: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Reveal.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactWaypoint2.default,
	      { onEnter: this.reveal },
	      _react2.default.createElement(
	        Revealable,
	        { show: this.state.revealed },
	        this.props.children
	      )
	    );
	  };
	
	  return Reveal;
	}(_react.Component);
	
	var SlidingUp = (0, _reactEmotion2.default)("div")(_templateObject2, function (_ref3) {
	  var show = _ref3.show;
	  return show ? "100" : "0";
	}, function (_ref4) {
	  var show = _ref4.show;
	  return show ? "translate(0,100px)" : "translate(0,0)";
	});
	
	var SlideUp = function (_Component2) {
	  _inherits(SlideUp, _Component2);
	
	  function SlideUp() {
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, SlideUp);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	      revealed: false
	    }, _this2.reveal = function () {
	      _this2.setState({ revealed: true });
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  SlideUp.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactWaypoint2.default,
	      { onEnter: this.reveal },
	      _react2.default.createElement(
	        SlidingUp,
	        { show: this.state.revealed },
	        this.props.children
	      )
	    );
	  };
	
	  return SlideUp;
	}(_react.Component);
	
	var HeavenlyRitualPage = function HeavenlyRitualPage() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Celebrating Mastery' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mastery-nav' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery', className: 'mastery-nav-link allegre' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(29) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'DEVILISH ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'PASSION'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery/devilish-tenacity', className: 'mastery-nav-link allegre' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(48) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'DEVILISH ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'TENACITY'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery/heavenly-pioneering', className: 'mastery-nav-link allegre' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(46) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'HEAVENLY ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'PIONEERING'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery/heavenly-patience', className: 'mastery-nav-link allegre' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(45) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'HEAVENLY ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'PATIENCE'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery/heavenly-ritual', className: 'mastery-nav-link allegre active' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(47) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'HEAVENLY ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'RITUAL'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/celebrating-mastery/devilish-details', className: 'mastery-nav-link allegre' },
	        _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(44) }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mastery-nav-link-text' },
	          'DEVILISH ',
	          _react2.default.createElement(
	            'span',
	            { className: 'red' },
	            'DETAILS'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mastery-block' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mastery-block-header' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-xl container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column col-4 col-sm-12' },
	              _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(47) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column col-6 col-sm-12' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'allegre' },
	                'HEAVENLY ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'red' },
	                  'RITUAL'
	                )
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                '\u3059\u3079\u3066\u306E\u9053\u306F\u5929\u306B\u901A\u305A'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '\u3053\u306E\u30B4\u30FC\u30EB\u30C7\u30F3\u30FB\u30A8\u30FC\u30EB\u3092\u6B63\u3057\u304F\u5473\u308F\u3046\u306B\u306F\u3001\u5FCD\u8010\u3068\u6B63\u78BA\u3055\u3092\u8981\u3059\u308B\u5100\u5F0F\u304C\u5FC5\u8981\u3060\u3002\u307E\u305A\u3001\u6E05\u6F54\u304B\u3064\u4E7E\u3044\u305F\u30C7\u30E5\u30D9\u30EB\u30B0\u30E9\u30B9\u3092\u5BA4\u6E29\u306B\u3057\u3066\u304A\u304F\u3053\u3068\u3002\u6CE8\u3050\u6642\u306F45\xB0\u306B\u50BE\u3051\u3001\u8C4A\u304B\u306A\u6CE1\u304C\u84CB\u3092\u3059\u308B\u3088\u3046\u3086\u3063\u304F\u308A\u7ACB\u3066\u3066\u3044\u304F\u3002\u30DC\u30C8\u30EB\u306B\u306F\u30D3\u30FC\u30EB\u30921cm\u6B8B\u3057\u3001\u74F6\u5E95\u306E\u9175\u6BCD\u3092\u30D3\u30FC\u30EB\u306B\u5165\u308C\u308B\u304B\u9078\u3076\u3053\u3068\u3002\u3059\u3079\u3066\u3092\u6210\u3057\u9042\u3052\u305F\u6642\u3001\u5929\u56FD\u306E\u9580\u306F\u958B\u304B\u308C\u308B\u3002'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mastery-block-body relative' },
	        _react2.default.createElement('img', { className: 'mastery-big-d', src: __webpack_require__(43) }),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-xl container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column col-6 col-md-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mastery-block-text' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'red' },
	                  '\u30C7\u30E5\u30D9\u30EB\u306E\u6B63\u3057\u3044\u5473\u308F\u3044\u65B9'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '1. \u6E05\u6F54\u306A\u30B0\u30E9\u30B9\u3092\u7528\u610F\u3002\u57C3\u3001\u6C34\u6EF4\u3001\u6307\u7D0B\u306A\u3069\u304C\u3064\u304B\u306A\u3044\u3088\u3046\u6CE8\u610F\u3059\u308B\u3053\u3068\u3002\u3053\u306E\u6642\u3001\u5FC5\u305A\u30B0\u30E9\u30B9\u306F\u4E7E\u3044\u3066\u3044\u308B\u3053\u3068\u3002\u6FE1\u308C\u3066\u3044\u308B\u3068\u30C7\u30E5\u30D9\u30EB\u306E\u7279\u5FB4\u7684\u306A\u8C4A\u304B\u306A\u6CE1\u304C\u7ACB\u3061\u306B\u304F\u3044\u3002'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '2. \u6CE8\u3050\u6642\u306F\u3001\u3088\u304F\u898B\u3048\u308B\u3088\u3046\u30DC\u30C8\u30EB\u3068\u30B0\u30E9\u30B9\u3092\u76EE\u306E\u9AD8\u3055\u306B\u6301\u3064\u300245\xB0\u306B\u50BE\u3051\u305F\u30B0\u30E9\u30B9\u306E\u5185\u5074\u306E\u58C1\u306B\u3001\u3086\u3063\u304F\u308A\u3068\u6CE8\u3044\u3067\u3044\u304F\u3053\u3068\u3002\u30DC\u30C8\u30EB\u306E\u534A\u5206\u307E\u3067\u6CE8\u3052\u305F\u3089\u3001\u5F90\u3005\u306B\u30B0\u30E9\u30B9\u3092\u7ACB\u3066\u3066\u3044\u304F\u3002\u305D\u306E\u307E\u307E\u3086\u3063\u304F\u308A\u6CE8\u3044\u3067\u3044\u304F\u3068\u3001\u6CE1\u304C\u5F62\u3065\u304F\u3089\u308C\u308B\u306E\u3092\u78BA\u8A8D\u3067\u304D\u308B\u3002'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '3. \u30DC\u30C8\u30EB\u306F\u4E2D\u8EAB\u3092\u6CE8\u304E\u5207\u3089\u306A\u3044\u3053\u3068\u3002 \u30D3\u30FC\u30EB\u306F1cm\u5206\u30DC\u30C8\u30EB\u306B\u6B8B\u3059\u3002\u5E95\u306B\u6B8B\u308B\u306E\u306F\u9175\u6BCD\u3067\u3001\u3053\u308C\u3092\u5165\u308C\u308B\u3068\u30D3\u30FC\u30EB\u304C\u6FC1\u3063\u3066\u3057\u307E\u3046\u3002'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '4. \u30B0\u30E9\u30B9\u306E\u30ED\u30B4\u534A\u5206\u307E\u3067\u30D3\u30FC\u30EB\u304C\u6CE8\u304C\u308C\u3001\u30B0\u30E9\u30B9\u306E\u7E01\u304B\u30891cm\u4E0B\u307E\u3067\u6CE1\u304C\u304D\u305F\u3089\u5B8C\u74A7\u3002'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '5. \u9175\u6BCD\u3092\u74F6\u5E95\u306B\u7559\u3081\u3066\u304A\u304F\u305F\u3081\u3001\u30DC\u30C8\u30EB\u306F\u7ACB\u3066\u305F\u72B6\u614B\u3067\u51B7\u8535\u3059\u308B\u3002\u9006\u3055\u306B\u3057\u3066\u4FDD\u5B58\u3059\u308B\u3068\u6CE8\u3050\u969B\u306B\u9175\u6BCD\u304C\u6DF7\u3056\u3063\u3066\u3057\u307E\u3046\u3002'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'video-wrapper' },
	                _react2.default.createElement(_reactPlayer2.default, {
	                  className: 'react-player',
	                  url: 'https://www.youtube.com/watch?v=fTVvuBaSku8',
	                  width: '90%',
	                  height: '90%'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column col-6 col-md-12' },
	              _react2.default.createElement('img', { className: 'img-responsive img-90', src: __webpack_require__(915) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'mastery-block-img-footer' },
	              _react2.default.createElement('img', { className: 'img-responsive', src: __webpack_require__(47) })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = HeavenlyRitualPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-celebrating-mastery-heavenly-ritual-js-d6a4c54baa031790f07e.js